export default __webpack_public_path__ + "static/media/send.980db74b.svg";